// Bulk room creation: pick a room type, say how many, and the rooms are named and numbered for you.

// The label used in room names is cleaned up (Generic OR → "OR", C/S (C-Section) → "C/S"); "Custom…"
// uses the free-text name instead.
export const ROOM_PRESETS = ['Generic OR', 'Endo', 'C/S (C-Section)', 'MRI', 'CT', 'Specials', 'EP', 'Cath Lab', 'PACU', 'Custom…'] as const;
export const CUSTOM_PRESET = 'Custom…';

export const presetLabel = (preset: string, custom: string): string => {
  switch (preset) {
    case 'Generic OR': return 'OR';
    case 'C/S (C-Section)': return 'C/S';
    case CUSTOM_PRESET: return (custom || '').trim();
    default: return preset;
  }
};

const escapeRe = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Names for `count` new rooms of type `label` at a hospital that already has rooms named `existingNames`.
 * Numbering continues from the rooms of that type already there ("Endo" × 2 next to Endo 1 → Endo 2,
 * Endo 3). A single room of a type the hospital doesn't have yet gets no number (one MRI is "MRI").
 */
export const nextRoomNames = (label: string, count: number, existingNames: string[]): string[] => {
  const re = new RegExp('^' + escapeRe(label) + '(?: (\\d+))?$', 'i');
  const existing = existingNames.filter(name => re.test(name)).length;
  if (existing === 0 && count === 1) return [label];
  return Array.from({ length: count }, (_, i) => `${label} ${existing + i + 1}`);
};
